<template>
  <div class="h-screen mt-[250px]">
    <HeaderBar :title="hTitle" />
    <ul class="list-disc my-4">
      <h2 class="font-bold">{{ ulTitle }}</h2>
      <UlListCheck :ulListCheck="items" />
    </ul>
  </div>
</template>

<script>
import HeaderBar from "../../components/HeaderBar.vue";
import UlListCheck from "../../components/CheckList.vue";
export default {
  components: { UlListCheck, HeaderBar },
  props: ["hTitle"],
  data() {
    return {
      title: "Monetary Requirements",
      ulTitle: "Payments required to initiate the title transfer:",
      items: [
        {
          id: 1,
          li: " The account must be fully paid",
          img: "icons/check.png",
        },
        {
          id: 2,
          li: " The Registration Fee / Title Transfer Fee must be fully paid based on the prevailing rate",
          img: "icons/check.png",
        },
        {
          id: 3,
          li: " Settle the updated Real Property Tax",
          img: "icons/check.png",
        },
      ],
    };
  },
};
</script>